<template>
  <div class="home">
    <navbar :is-active="2"></navbar>
    <div class="body">
      <div class="body__sidebar" id="body__sidebar">
        <div class="nav-mob-resp">
        <hidden-arrow></hidden-arrow>
        <div class="title">
          <div class="title__icon">
            <i class="fas fa-home"></i>
          </div>
          <div class="title__text">
            <h2>{{company_name}}</h2>
            <p>Selecciona una opción</p>
          </div>
        </div>
        <div class="tabs">
          <router-link to="/Client/cp-productos" class="tab">
            <div class="tab__icon">
              <i class="fab fa-product-hunt"></i>
            </div>
            <div class="tab__text">
              <p>Productos</p>
            </div>
          </router-link>
          <router-link to="/Client/cp-clientes" class="tab active">
            <div class="tab__icon">
              <i class="fas fa-user-friends"></i>
            </div>
            <div class="tab__text">
              <p>Clientes</p>
            </div>
          </router-link>
          <router-link to="/Client/cp-boletas" class="tab">
            <div class="tab__icon">
              <i class="fas fa-file-invoice-dollar"></i>
            </div>
            <div class="tab__text">
              <p>Boletas</p>
            </div>
          </router-link>
        </div>
        </div>
      </div>
      <div class="body__containt">
        <div class="page__title">
          <open-arrow></open-arrow>
          <h2>Clientes</h2>
        </div>

        <div class="page__filters">
          <input
            v-model="code_client"
            @keyup="search"
            type="text"
            placeholder="Código de cliente"
          />
          <input
              v-model="cellphone"
              @keyup="search"
              type="text"
              placeholder="Celular"
          />
          <input
              v-model="user_name"
              @keyup="search"
              type="text"
              placeholder="Nombre"
          />
          <p @click="clean_filter()" class="clean_filter">Limpiar Filtros</p>

        </div>
        <div class="page__buttons">
          <ButtonExport
            :data="clients_export"
            :columns="columns"
            icon="fas fa-download"
            :sheet-name="'Datos Clientes'"
            :file-name="'Reporte Clientes'"
          />
        </div>
        <div class="page__table">
          <div class="table-headers">
            <p v-for="{ label } of columns" :key="label">{{ label }}</p>
            <p>Accion</p>
          </div>
          <div class="table-body">
            <div class="data" v-for="client of clients" :key="client.invoice_id">
              <p>
                {{ codeFormat(client.invoice_user_id) }}
              </p>
              <p>{{ client.user_name }}</p>
              <p>{{ client.user_lastname }}</p>
              <p>{{ client.email }}</p>
              <p>{{ client.cellphone }}</p>
              <div class="dropdown" >
                  <button class="button" @click="show('id-dropdown-content'+client.invoice_id)">
                    <i class="fa fa-ellipsis" style="color: red"></i>
                  </button>
                  <div @mouseleave="show('id-dropdown-content'+client.code_users)"  class="dropdown-content" :id="'id-dropdown-content'+client.invoice_id">
                    <router-link :to="{ path: '/ClienteConciliaDetalleCliente', query: { id: client.code_users }}" class="dropdown-item">
                      <i class="far fa-eye " ></i> Buscar cliente
                    </router-link>  
                      <div class="dropdown-item-special">
                        Activado
                        <input
                            :id="'check_'+client.code_users"
                            type="checkbox"
                            :checked="(client.user_status === 1)"
                            class="dropdown-checkbox"
                            @change="activateUser($event, client.code_users)"
                        />
                        <label class="wrapper" :for="'check_'+client.code_users">
                          <span class="circle"></span>
                        </label>
                      </div>
                  </div>
                </div>
            </div>
            <div style="text-align: center;" v-if="empty">
              <h4 style="color: #938f8f; padding: 50px;">No se encontraron datos</h4>
            </div>
          </div>
        </div>
        <div class="page__pagination">
          <Pagination
              :data="pagination"
              v-on:changePage="handleClickInParent"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import axios from 'axios'
  import Navbar from '@/components/NavBar'
  import { codeFormat } from '@/utils/formats'
  import Dropdown from '@/components/Dropdown.vue'
  import ButtonExport from '@/components/ButtonExport.vue'
  import Pagination from '@/components/Pagination.vue'
  import OpenArrow from '@/components/OpenArrow.vue'
  import HiddenArrow from '@/components/HiddenArrow.vue'
  import $ from 'jquery'

  export default {
    name: 'Clientes',
    components: {
      Navbar,
      ButtonExport,
      Dropdown,
      Pagination,
      OpenArrow,
      HiddenArrow
    },
    data() {
      return {
        type: 'Clientes',
        code_client: '',
        cellphone: '',
        user_name: '',
        clients_export: [],
        empty: false,
        timeout: null,
        pagination: [],
        descargarBoleta: axios.defaults.baseURL + 'general/download/invoice/',
        showDropdwon: true,
        checked: true,
        columns: [
          {
            label: 'Código de cliente',
            field: 'invoice_user_id',
            dataFormat: this.codeFormat
          },
          { label: 'Nombres', field: 'user_name' },
          { label: 'Apellidos', field: 'user_lastname' },
          { label: 'Correo electrónico', field: 'email' },
          { label: 'Celular', field: 'cellphone' }
        ]
      }
    },
    
    methods: {
      show(divID){
        if (!$("body").hasClass("cerrarModal")){
          $('#'+divID).fadeIn();
          setTimeout(function () {
            $("body").addClass("cerrarModal");
          }, 10);
        }
      },
      activateUser(e, id){
        let data = {
          user_status: (e.target.checked) ? 1 : 0
        }
        axios.put('user/'+id, data)
        this.search()
        this.$swal({
          position: 'center',
          icon: 'success',
          title: (e.target.checked) ? 'Activado correctamente': 'Desactivado correctamente',
          showConfirmButton: false,
          timer: 2000
        })
      },

      handleClickInParent: function(page) {
        this.getall(page)
      },
      codeFormat,
      clean_filter(){
        this.code_client = ''
        this.cellphone = ''
        this.user_name = ''
        this.getall()
      },
      search: function() {
        clearTimeout(this.timeout);
        var self = this;
        this.timeout = setTimeout(function () {
          console.log(self)
          let paramSearch = {
            code_client: self.code_client,
            cellphone: self.cellphone,
            user_name: self.user_name,
          }
          this.getall(1, paramSearch)
        }.bind(this), 500);
      },
      handleClick() {
        localStorage.removeItem('token')
        this.$router.push('/login')
      },
      async getall(page = 1, paramSearch = {}) {
        await axios.get('general/conciliationclient', {params: {
          page: page,
          company_id: localStorage.getItem('company_id'),
          code_client: (paramSearch.code_client) ? paramSearch.code_client : null,
          cellphone: paramSearch.cellphone,
          user_name: paramSearch.user_name,
        }}).then( res => {
          if(res.data.data.total > 0){
            this.clients = res.data.data.data
            this.pagination = res.data.data
            this.clients_export = res.data.export
            this.empty = false
            console.log(this.clients_export)
            console.log(this.clients)
          }else{
            this.clients = {}
            this.pagination = {}
            this.empty = true
          }
        })
      }
    },
    created() {
      this.getall()
      this.company_name = localStorage.getItem('company_name');
    }
  }
</script>

<style scoped>
  .home {
    width: 100vw;
    height: 100vh;
    display: flex;
    flex-direction: column;
    font-family: 'Readex Pro', sans-serif;
  }
  .body {
    width: 100%;
    height: 600px;
    display: flex;
  }
  .body__containt {
    height: calc(100vh - 120px);
    box-shadow: 1px 10px 10px rgba(0, 0, 0, 0.1);
  }
  .body__sidebar {
    width: 400px;
    position: relative;
    display: flex;
    flex-direction: column;
  }

  .body__sidebar .floating-icon {
    position: absolute;
    right: -15px;
    top: 30px;
    color: #ff3128;
    font-size: 30px;
  }

  .body__sidebar .title {
    width: 100%;
    height: 140px;
    border-bottom: 1px solid #b6b6b6;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .body__sidebar .title__icon {
    color: #ff3128;
    font-size: 20px;
  }
  .body__sidebar .title__text {
    margin: 0 10px;
  }

  .body__sidebar .title__text h2 {
    font-size: 20px;
    margin: 0;
  }
  .body__sidebar .title__text p {
    margin: 0;
    font-weight: 300;
  }

  .body__sidebar .tabs {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    height: calc(100% - 140px);
    padding-top: 5px;
  }

  .body__sidebar .tabs .tab {
    width: 90%;
    height: 70px;
    border-radius: 10px;
    color: #707070;
    display: flex;
    align-items: center;
    padding: 0 20px;
    margin-bottom: 10px;
    cursor: pointer;
    transition: 0.3 ease;
  }
  .body__sidebar .tabs .tab:hover,
  .body__sidebar .tabs .tab.active {
    color: #ff3128;
    background: #ffeeed;
  }

  .body__sidebar .tabs .tab__icon {
    font-size: 20px;
    margin-right: 10px;
  }

  .body__sidebar .tabs .tab__text p {
    margin: 0;
    font-weight: 600;
  }

  .body__containt {
    height: fit-content;
    min-height: 87vh;
    width: 100%;
    display: flex;
    flex-direction: column;
    padding: 20px 30px;
  }

  .body__containt .page__title {
    width: 100%;
    margin-bottom: 20px;
  }

  .body__containt .page__title h2 {
    font-weight: 600;
    color: #ff3128;
    font-size: 25px;
  }

  .body__containt .page__filters {
    display: flex;
    justify-content: flex-start;
    flex-wrap: wrap;
    gap: 20px;
  }
  .body__containt .page__filters input,
  select {
    border-radius: 10px;
    border: 1px solid #e4e4e4;
    background: #fff;
    padding: 15px 20px;
    /*margin: 0 10px;*/
    width: 300px;
  }

  .body__containt .page__buttons {
    width: 100%;
    display: flex;
    justify-content: flex-end;
    gap: 20px;
    padding-top: 2%;
  }

  .body__containt .page__buttons .button {
    width: 250px;
    padding: 15px 20px;
    border-radius: 15px;
    font-size: 17px;
    color: #fff;
    border: none;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .body__containt .page__buttons .button:nth-child(1) {
    background: #262626;
  }

  .body__containt .page__table {
    width: 100%;
    min-height: 200px;
    display: flex;
    flex-direction: column;
    margin-top: 50px;
  }

  .body__containt .page__table .table-headers {
    width: 100%;
    height: 50px;
    display: flex;
    justify-content: space-between;
    border-bottom: 1px solid #b6b6b6;
  }
  .body__containt .page__table .table-headers p {
    width: calc(100% / 7);
    display: flex;
    justify-content: center;
    align-items: center;
    font-weight: 600;
  }

  .body__containt .page__table .table-body {
    width: 100%;
    display: flex;
    flex-direction: column;
    border-bottom: 1px solid #b6b6b6;
  }

  .body__containt .page__table .table-body .data {
    width: 100%;
    display: flex;
    justify-content: space-between;
  }
  .body__containt .page__table .table-body .data p {
    width: calc(100% / 7);
    display: flex;
    justify-content: center;
    align-items: center;
    font-weight: 300;
    margin: 10px 0;
  }
  .body__containt .page__table .table-body .data p:nth-child(1) {
    color: #ff3128;
  }
  .body__sidebar.open{
    display: none;
  }
  /* INICIO MOBILE*/
  @media (max-width: 768px){
    .body__containt .page__title h2{
      font-size: 21px;
    }
    .body__containt .page__filters input{
      padding: 5px 20px;
    }
    .page__filters select{
      padding: 10px 19px;
      width: 54% !important;
    }
    .body label{
      margin-top: 2rem;
      margin-left: 18px;
      font-size: 13px;
    }
    .body p.clean_filter{
      margin-top: 7px;
      font-size: 14px;
    }
    .buttonExport{
      margin-top: -13px;
      width: 179px;
      padding: 9px 20px;
    }
    .body__containt .page__table{
      font-size: 11px;
    }
    .body__containt .page__table .table-headers{
      margin-top: 6px;
      width: 245%;
    }
    .body__containt .page__table .table-body{
      width: 245%;
    }
    .body__containt .page__table .table-body{
      width: 245%;
    }
    .body__sidebar .title__text h2 {
      font-size: 18px;
    }
    .body__sidebar .title__text {
      margin: 0 10px;
      font-size: 16px;
    }
    .body__sidebar .title__icon{
      font-size: 16px;
      margin-left: 6px;
    }
    .body__sidebar .tabs .tab__icon svg{
      font-size: 15px;
      margin-right: 7px;}
    .body__sidebar .tabs .a{
      margin-left: -2px;
      margin-top: -1px;
    }
    .body__sidebar a svg{
      font-size: 22px;
    }
    /*BARRA LATERAL IZQUIERDA MOBILE*/
    .body__sidebar .tabs .tab__icon {
      color: white;
    }
    .body__sidebar .tabs .tab:hover, .body__sidebar .tabs .tab.active svg {
      color: #ff3128;
    }
    .body__sidebar .tabs .tab:hover, .body__sidebar .tabs .tab.active p {
      color: #ff3128;
      font-size: 20px;
    }
    .body__sidebar .tabs .tab__text p {
      margin-left: -8px;
      color: white;
      font-size: 18px;
    }
    .body__sidebar .tabs .tab:hover, .body__sidebar .tabs .tab.active{
      background: #262626;
      margin-bottom: -11px;
    }
    .body__containt .page__buttons .button{
      font-size: 13px;
      padding: 5px 20px;
      margin-top: -18px;
    }
    .body__containt .page__buttons {
      width: 105%;
    }
    .home .body .nav-mob-resp{
      position: absolute;
      background: #262626;
      height: 85vh;
      width: 25vh;
    }
    .body__sidebar .title {
      color: white;
    }
    .body__sidebar .floating-icon {
      position: absolute;
      right: -35px;
    }
    .body__sidebar .tabs .tab{
      margin-bottom: -7px;
    }
  }
</style>
